import { useEffect, useState } from "react";
import CreateEmailFormView from "../../Views/TO/Register/Local/CreateEmailFormView";
import axios from "axios";
import { useGotoUrlContext } from "../../../withGotoUrl";
import pushAnalytics from "../../../analytics/pushAnalytics.js";

import AppVars from "../../../AppVars.js";
const appVars = AppVars.getInstance();

const EMAIL_VERIFICATION_URL = "/emailverification";
const PHONE_VERIFICATION_URL = "/phoneverification";
const OTP_LOGIN_URL = "/otplogin";
const DEALER_URL = "/dealer";
const INVALID_CREDS_URL = "/invalidcreds";
const ACCOUNT_LOCKED_URL = "/accountlocked";
const UNKNOWN_ERROR_URL = "/unknownerror";
const RESEND_ACTIVATION_EMAIL_URL = "/resend";
const PHONE_TYPE = "PHONE";
const EMAIL_TYPE = "EMAIL";
const INPUT_TYPES = {
  EMAIL:
    "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)",
};
const NEEDS_USERNAME = [
  RESEND_ACTIVATION_EMAIL_URL,
  EMAIL_VERIFICATION_URL,
  PHONE_VERIFICATION_URL,
  OTP_LOGIN_URL,
  DEALER_URL,
];

const COMPONENT_TREE = [
  { component_name: 'RegisterForm', component_version: '1.0.0' },
  { component_name: 'CreateEmailForm', component_version: '1.0.0' }
];

const CreateEmailForm = (props) => {
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(null);
  const [loading, setLoading] = useState(false);
  const [onFocus, setOnFocus] = useState(false);
  const [floatLabel, setFloatLabel] = useState(true);

  const gotoUrlContext = useGotoUrlContext();
  useEffect(() => {
    setEmail(gotoUrlContext.initialUsername);
    if (gotoUrlContext.initialUsername) {
      setFloatLabel(false);
      setIsEmailValid(validateUsername(gotoUrlContext.initialUsername));
    }
  }, [gotoUrlContext.initialUsername]);

  const handleFormSubmit = async (event) => {
    const checkEmailAvailability = async (email) => {
      const handleErrorResponse = (err) => {
        pushAnalytics("sys-action", { form_name: "email-entry-form", error_type: 'backend-error', metrics: 'km-form_field_submit-error' }, COMPONENT_TREE);
        props.setResponseValid(false);
      };

      const handleResponse = (emailAvailabilityResponse) => {
        if (emailAvailabilityResponse.status > 299) {
          props.setResponseValid(false);
        } else if (!emailAvailabilityResponse.data.isAvailable) {
          pushAnalytics("sys-action", { form_name: "email-entry-form", error_type: 'email-already-registered', displayed_error_message: 'Email Already Exists', metrics: 'km-form_field_submit-error' }, COMPONENT_TREE);
          props.setResponseValid(true);
          props.displayForm("EXISTS");
        } else {
          props.setResponseValid(true);
          props.setEmailAvailable(true);
          props.setEmail(email);
          props.displayForm("PASSWORD");
        }
      };

      try {
        const response = await dcsCheckEmailAvailability(email);
        handleResponse(response);
        return {
          response: response.data,
          status: response.status,
        };
      } catch (err) {
        handleErrorResponse(err);
        return {
          response: err.response.data,
          status: err.response.status,
        };
      }
    };

    //Prevent default submit button behavior
    event.preventDefault();

    setLoading(true);
    //Check that form isn't blank
    const valid = validateUsername(email);
    setLoading(false);

    if (valid) {
      props.setEmail(email);
      setLoading(true);
      await checkEmailAvailability(email);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setIsEmailValid(validateUsername(event.target.value));
  };

  const validateUsername = (username) => {
    if (username == null || username.length === 0 || checkUsernameType(username) === null) {
      pushAnalytics("sys-action", { form_name: "email-entry-form", field_name: 'email', error_type: 'validation', displayed_error_message: 'Please enter a valid email address.', metrics: 'km-form_field_entry-error' }, COMPONENT_TREE);
      return false;
    }
    return true;
  };

  const onBlur = () => {
    if (email === "") {
      setFloatLabel(true);
    } else {
      setFloatLabel(false);
    }
    setIsEmailValid(validateUsername(email));
    removeFocus();
  };

  const setFocus = (event) => {
    setOnFocus(true);
    setFloatLabel(false);
  };

  const removeFocus = () => {
    setOnFocus(false);
  };

  return (
    <CreateEmailFormView
      style={props.style}
      email={email}
      loading={loading}
      floatLabel={floatLabel}
      isEmailValid={isEmailValid}
      handleFormSubmit={handleFormSubmit}
      handleEmailChange={handleEmailChange}
      onFocus={onFocus}
      setFocus={setFocus}
      removeFocus={removeFocus}
      onBlur={onBlur}
    />
  );
};

async function dcsCheckEmailAvailability(email) {
  const headers = { "x-brand": "T", "x-client": "FR-Portal-Toyota", }
  const url = appVars.getAPIGatewayURL() + "/availability";
  const params = { email: email, };
  return await axios({ headers, method: "get", params, url, });
}

function checkUsernameType(username) {
  let TYPE = null;
  for (const key in INPUT_TYPES) {
    if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
      TYPE = key;
    }
  }
  return TYPE;
}

export default CreateEmailForm;